// src/assets/logo/MapLogo.jsx

export const MapLogo = ({ className = "", ...props }) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 67 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M33.5 0C52.0043 0 66.9999 14.9957 67 33.5C67 59.7751 33.5 83.166 33.5 83.166C33.5 83.166 0 58.4757 0 33.5C5.03759e-05 14.9958 14.9958 0.000109573 33.5 0ZM33.5 18.8467C26.8042 18.8467 21.3761 24.2749 21.376 30.9707C21.376 37.6666 26.8041 43.0947 33.5 43.0947C40.1958 43.0946 45.624 37.6665 45.624 30.9707C45.6239 24.2749 40.1958 18.8468 33.5 18.8467Z"
      fill="white"
    />
  </svg>
);
